import {Link, NavLink} from "react-router-dom";
import React, {Fragment, useRef} from "react";
import {Skeleton} from "@mui/material";
import {
    FormatNumberByhkh,
} from "../../clientconfigwebapp";
import LazyLoad_post_lg from "react-lazy-load";
import '../assets/css/Post_product_Gride.css';




import ProductCard from "../../components/Card_boxs/ProductCard";
const Post_product_Gride = (props) => {

    let link_post_get="/"+props.link_to;
    link_post_get=link_post_get.replaceAll("//","")



    return (
        <>
            <div className='w-100 cate-items-container'>

            {
                props.data_posts_list.length  > 0 ?  (


                props.data_posts_list.map((item_post,index) => {

                    var link_full=String(props.link_post_main)  + "/" + String(item_post.id_post);
                    return (

<Fragment>
<ProductCard  data_full_curent_item={item_post}    />
</Fragment>



                );

                })



            ) : (






                <React.Fragment>

                    <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                    <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />

                    <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                    <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />

                </React.Fragment>



            ) }

</div>
        </>
    );

}
export default Post_product_Gride;

